import paths from 'routing/routes/_paths';

import Authorization from 'views/authorization';

const routes = [
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.authorization,
    component: Authorization,
    documentTitle: 'Authorization'
  }
];

export default routes;
